<template>
    <BaseLink 
        class="zetta__logo" 
        tag="a"
        path="/"
        >
        <img class="zetta__logo-pic" src="@/assets/images/logo-zetta.png" alt="Логотип Zetta">
    </BaseLink>
</template>

<script>
import BaseLink from '@/components/ui/BaseLink';

export default {
    name: 'ZettaLogo',
    components: {
        BaseLink
    }
}
</script>

<style scoped lang="scss">
.zetta__logo {
    $width-desktop: 138px;
    $height-desktop: 50px;

    $width-desktop-min: 87px;
    $height-desktop-min: 33px;

    display: block;

    width: rem($width-desktop);
    height: rem($height-desktop);

    &-pic {
        @include object-cover-full;
    }

    @media #{$screen-big} {
        width: rem($width-desktop-min);
        height: rem($height-desktop-min);
    }
}
</style>